import React from 'react'
import classes from './Description.module.css'
import Image1 from '../../../Assests/Image/group_5.png'
const Description = ()=>{
    return(
        <div className={classes.item}>
        <div className={classes.Container}>
           
            <div className={classes.content}>
        <p className={classes.heading}>
        About Glossaread
       </p>
        <p className={classes.subHeading} >
            Do you also face these problems?
            </p>
        <ul>
            <li className={classes.li}><p className={classes.list}>Expensive books</p></li>
            <li className={classes.li}><p className={classes.list}>Poor Library Infra</p></li>
            <li className={classes.li}><p className={classes.list}>Vast syllabus</p></li>
            <li className={classes.li}><p className={classes.list}>Endless lines at photocopier for notes</p></li>
            <li className={classes.li}><p className={classes.list}>Multiple fragmented sources of studying - class notes, senior's notes, photocopy notes, etc</p></li>
        </ul>
        <p className={classes.subHeading} >
          Worry no more,Gossaread is here to rescue You all
            </p>
           
        <ul>
            <li className={classes.li}><p className={classes.list}>Buy individual chapters starting at only Rs.8/-</p></li>
            <li className={classes.li}><p className={classes.list}>All reference books available online at minimal prices</p></li>
            <li className={classes.li}><p className={classes.list}>Vast syllabus in a simple, concise form of ppts &amp; notes</p></li>
            <li className={classes.li}><p className={classes.list}>Notes prepared by professors themselves</p></li>
            <li className={classes.li}><p className={classes.list}>All your study material in one place to help you focus better</p></li>
        </ul>
        {/* <button className={classes.btn}>Sign Up</button> */}
            </div>
            <div className={classes.illustration}>
            <img   className={classes.image} src={Image1} alt="alt"></img>
            </div>
            </div>
        </div>
    )
}
export default Description